import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';
import { reducer as form } from 'redux-form';

import session from './sessionReducer';
import entities from './entitiesReducer';
import ducks from './ducksReducer';

export default combineReducers({
  router,
  session,
  entities,
  form,
  ducks,
});
